import styled from 'styled-components'

export const StyledLobby = styled.div`
  #game-stand {
    position: absolute;
    left: 11%;
    bottom: 9%;
    cursor: pointer;
  }
  #current-user {
    pointer-events: none;
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 10px;
    color: gray;
  }
  #banner {
    position: absolute;
    cursor: pointer;
    top: 41.3%;
    bottom: 35.1%;
    left: 47.3%;
    right: 45.1%;
  }
  .video-container {
    position: absolute;
    top: 14%;
    left: 37.7%;
    width: 26.7%;
    height: 26.5vh;

    div {
      height: 100%;

      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
`
